import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ZefProgressState, ZefProgressMap } from './progress.model';
import { FEATURE_NAME } from './progress.constant';
import { ZefKeyInput, filterByKeyInput } from '@zerops/zef/core';

export const selectZefProgressState = createFeatureSelector<ZefProgressState>(FEATURE_NAME);

export const selectZefProgresses = createSelector(
  selectZefProgressState,
  (state) => state.progress
);

export const selectZefProgressByTypeAndId = (key: string, id: string) => createSelector(
  selectZefProgresses,
  (state) => state.find((p) => p.key === key && id === id)
);

export const selectZefProgressByTypeAndTag = (key: string, tag: string) => createSelector(
  selectZefProgresses,
  (state) => state.find((p) => p.key === key && tag === p.tag)
);

export const selectZefProgressByType = (key: string) => createSelector(
  selectZefProgresses,
  (state) => state.find((p) => p.key === key)
);

export const selectZefProgressesByType = (keyInput: ZefKeyInput) => createSelector(
  selectZefProgresses,
  (state) => filterByKeyInput(state, keyInput)
);

export const selectZefProgressMapByType = (keyInput: ZefKeyInput) => createSelector(
  selectZefProgresses,
  (state) => filterByKeyInput(state, keyInput)
    .filter((p) => !!p.id)
    .reduce((obj, p) => {
      if (!obj[p.id]) {
        obj[p.id] = {};
      }

      obj[p.id][p.key] = p;

      return obj;
    }, {}) as ZefProgressMap
);
